import {modalMoveMeeting} from "./move-to/move"
import Meeting from "../model2/meeting/meeting";

export default class MeetingModalsManager {

    addUsers(projectId: ID, meetingUsers: ID[], callback?: any) {
        gd.modal.showV4({
            className: 'modal-add-user',
            component: require('./add-user/add-meeting-user'),
            params: {
                onSubmit    : (newUsers: any)=>{
                    if (callback) callback(newUsers);
                    gd.modal.hide();
                },
                projectId   : projectId,
                users       : meetingUsers
            }
        })
    }

    moveToFolder(meeting: Meeting, callback?: {(projectId: ID): void}) {
        return modalMoveMeeting(meeting, {
            callback: callback,
        })

        /*gd.modal.showV4({
            className: 'modal-move',
            component: ModalMoveTo,
            params: {
                meetingId: meetingId,
                companyId: gd.companyId,
                parentProjectId: parentProjectId,
                arrMeetingUsers: arrMeetingUsers,
                mode: ModalMoveTo_Mode.MEETING,
                type: ModalMoveTo_TargetType.FOLDER,
                onMove: callback
            }
        });*/
    }
}